import CustomCard from '@components/CustomCard';
import styled from 'styled-components';

export const DashContainer = styled.div`
  .ant-statistic-content-value {
    font-size: ${({ theme }) => theme.fontSizes.large} !important;
    line-height: ${({ theme }) => theme.fontSizes.large} !important;
  }

  .ant-statistic-content-suffix {
    font-size: ${({ theme }) => theme.fontSizes.default} !important;
    line-height: ${({ theme }) => theme.fontSizes.default} !important;
  }

  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const CardContainer = styled(CustomCard)`
  .ant-col {
    color: ${({ theme }) => theme.colors.text1};
  }
  .status-menu-title {
    margin-left: 12px;
    line-height: 1rem;
    font-size: 0.9rem;
  }
  .card-select-filter {
    @media (max-width: 375px) {
      width: 10rem !important;
    }
  }

  @media (max-width: 375px) {
    .status-menu-button-all {
      width: 100%;
      height: auto;
    }

    .status-menu-button-all > span {
      white-space: break-spaces;
    }
  }
  .status-menu-card {
    font-size: 1.1rem;
  }

  .ant-tabs-tab {
    cursor: default !important;
  }

  .card-title {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    color: ${({ theme }) => theme.colors.text};

    .anticon-question-circle {
      svg {
        width: 1.2rem;
        height: 1.2rem;
        fill: ${({ theme }) => theme.colors?.text};
      }
    }

    .ant-tabs {
      padding: 0;
    }

    .ant-tabs-tab {
      margin: 0;

      .ant-tabs-ink-bar {
        padding: 20px;
      }
    }

    .ant-radio-group {
      z-index: 0;
    }

    .ant-radio-button-wrapper {
      margin: 0;
      flex-wrap: wrap;

      span {
        font-weight: normal;
      }
    }

    @media (max-width: 500px) {
      justify-content: center;

      .ant-radio-group {
        margin-top: 16px;
      }
    }
  }

  .ant-card-body {
    padding: 16px;
    height: 100%;

    .ant-statistic {
      display: flex;
      flex-direction: column;
    }

    .ant-statistic-title {
      margin-bottom: 8px;
      font-weight: 500;
      font-size: ${({ theme }) => theme.fontSizes.small};
      color: ${({ theme }) => theme.colors.text1};
    }

    .ant-statistic-content {
      display: inline-flex;
      align-items: center;
    }

    .ant-statistic-content-value {
      color: ${({ theme }) => theme.colors.primary};
      font-size: ${({ theme }) => theme.fontSizes.large};
      line-height: ${({ theme }) => theme.fontSizes.large};
    }

    .ant-statistic-content-suffix {
      color: ${({ theme }) => theme.colors.text1};
      font-size: ${({ theme }) => theme.fontSizes.small};
      line-height: ${({ theme }) => theme.fontSizes.small};
    }
  }

  [data-chart-source-type='G2Plot'] {
    > div {
      z-index: 0;
    }
  }

  .g2-html-annotation {
    opacity: 0.8;
    font-size: 1.4rem !important;
    color: ${({ theme }) => theme.colors.text1} !important;
  }

  .g2-html-annotation + .g2-html-annotation {
    margin-top: 8px !important;
    font-size: 1.8rem !important;
    color: ${({ theme }) => theme.colors.text} !important;
  }
`;

export const BaseEvolutionMenuCardContainer = styled.div`
  .status-menu-card {
    font-size: ${({ theme }) => theme.fontSizes.large} !important;
    line-height: ${({ theme }) => theme.fontSizes.large} !important;
    color: ${({ theme }) => theme.colors.primary};
  }

  .status-menu-title {
    color: ${({ theme }) => theme.colors.text1};
    font-size: ${({ theme }) => theme.fontSizes.small};
    line-height: ${({ theme }) => theme.fontSizes.small};
  }
`;
